import { useEffect, useRef, useState } from 'react';
import { CasinoGame } from '@/types/casino';
import { SkeletonCard } from './CasinoCardSkeleton';

interface Props {
  game: CasinoGame;
  onClick?: (game: CasinoGame) => void;
}

export default function CasinoGameCard({ game, onClick }: Props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    setIsLoaded(false);
    // cached images can finish loading before React attaches onLoad
    if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
      setIsLoaded(true);
    }
  }, [game.gameImage]);

  return (
    <button
      type="button"
      onClick={() => onClick?.(game)}
      className="group relative aspect-square w-full overflow-hidden rounded-xl animate-fade-in"
    >
      {!isLoaded && <SkeletonCard className="absolute inset-0 z-10 !rounded-xl" />}
      <img
        ref={imgRef}
        src={game.gameImage}
        alt={game.name}
        className={`h-full w-full object-cover object-center transition-[transform,opacity] duration-300 group-hover:scale-105 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        onLoad={() => setIsLoaded(true)}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = '/images/casino-card-placeholder.webp';
        }}
      />
    </button>
  );
}
